let server="https://stream.m4u.live:8005";

let stream = `${server}/stream`;
let stat = `${server}/status-json.xsl`

export {stream, stat};